import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { BancosService } from 'src/app/services/bancos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-cadastro-bancos',
    templateUrl: './modal-cadastro-bancos.component.html',
    providers: [BancosService]
})

export class ModalCadastroBancosComponent implements OnInit {

    modalRef: NgbModalRef;
    public banco: any;

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private appService: AppService,
        private bancosService: BancosService,
        private dadosCargasService: DadosCargasService,
    ) {

    }

    popularNovoBanco() {
        this.banco = {
            nome: '',
            estado: '',
        };
    }

    ngOnInit(): void {
        this.popularNovoBanco();
    }

    cadastrar() {
        this.add(this.banco);
    }

    add(banco) {
        this.spinner.show();
        this.toastrService.clear();
        this.bancosService.add(banco)
            .subscribe(res => {
                this.toastrService.success("Banco cadastrado.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o banco!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}